<form class="zn-form">
  <fieldset [disabled]="loading()">
    <div class="row">
      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="inventoryProjectionRegion">
            {{ 'Planning::Entity.Region' | abpLocalization }}
          </label>
          <zn-multi-select
            #regionSelect
            id="inventoryProjectionRegion"
            [options]="regionOptions()"
            [showSearch]="true"
            [deferSelection]="false"
            (selectedChange)="onRegionSelectionChange($event)"
          ></zn-multi-select>
        </div>
      </div>

      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="inventoryProjectionProperty">
            {{ 'Planning::Entity.Property' | abpLocalization }}
          </label>
          <zn-multi-select
            #propertySelect
            id="inventoryProjectionProperty"
            [options]="propertyOptions()"
            [showSearch]="true"
            [deferSelection]="false"
            (selectedChange)="onPropertySelectionChange($event)"
          ></zn-multi-select>
        </div>
      </div>

      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="inventoryProjectionStand">
            {{ 'Planning::Entity.Stand' | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-multi-select
            #standSelect
            id="inventoryProjectionStand"
            [options]="standOptions()"
            [showSearch]="true"
            [deferSelection]="false"
            (selectedChange)="onStandSelectionChange($event)"
          ></zn-multi-select>
          @if (showStandSelectionError()) {
            <small class="invalid-feedback d-block">{{ standSelectionRequiredKey | abpLocalization }}</small>
          }
        </div>
      </div>
    </div>
  </fieldset>
</form>
